import {
  DropdownMenu,
  DropdownItem,
  Rate,
  Button,
  Icon,
  Tabbar,
  TabbarItem,
  Swipe,
  SwipeItem,
  List,
  PullRefresh,
  Search,
  Popup,
  Popover,
  Space,
  Tab,
  Tabs,
  FloatingPanel,
  Form,
  Field,
  Picker,
  Uploader,
  Area,
  Cell,
  CellGroup,
  Notify,
  Checkbox,
  Radio,
  RadioGroup,
  Dialog
} from "vant"
const loadVantComponets = (appElement: any = null) => {
  if (appElement && typeof appElement.use === "function") {
    return appElement
      .use(Button)
      .use(Icon)
      .use(Tabbar)
      .use(TabbarItem)
      .use(Swipe)
      .use(SwipeItem)
      .use(List)
      .use(PullRefresh)
      .use(Search)
      .use(Rate)
      .use(DropdownMenu)
      .use(DropdownItem)
      .use(Popup)
      .use(Popover)
      .use(Space)
      .use(Tab)
      .use(Tabs)
      .use(FloatingPanel)
      .use(Form)
      .use(Field)
      .use(Picker)
      .use(Uploader)
      .use(Area)
      .use(Cell)
      .use(CellGroup)
      .use(Notify)
      .use(Checkbox)
      .use(Radio)
      .use(RadioGroup)
      .use(Dialog)
  }

  throw new Error("AppElement is not a validate object~")
}

export default loadVantComponets
